import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  async syncEvent(event) {
    const button = event.currentTarget
    const eventId = button.dataset.eventId
    const originalText = button.querySelector('span').textContent

    // Disable button and show loading state
    button.disabled = true
    button.classList.add('opacity-75', 'cursor-not-allowed')
    button.querySelector('span').textContent = 'Syncing...'

    try {
      const response = await fetch(
        `/events/${eventId}/sync_to_google_calendar`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]')
              .content,
          },
        }
      )

      const data = await response.json()

      if (data.success) {
        // Show success message
        button.querySelector('span').textContent = '✓ Synced!'
        button.classList.remove('bg-orange-500', 'hover:bg-orange-600')
        button.classList.add('bg-green-500', 'hover:bg-green-600')

        // Show notification
        this.showNotification(data.message, 'success')

        // Reset button after 3 seconds
        setTimeout(() => {
          button.querySelector('span').textContent = 'Update Google Calendar'
          button.classList.remove('bg-green-500', 'hover:bg-green-600')
          button.classList.add('bg-orange-500', 'hover:bg-orange-600')
          button.classList.remove('opacity-75', 'cursor-not-allowed')
          button.disabled = false
        }, 3000)
      } else {
        // Show error message
        button.querySelector('span').textContent = 'Sync Failed'
        button.classList.remove('bg-orange-500', 'hover:bg-orange-600')
        button.classList.add('bg-red-500', 'hover:bg-red-600')

        this.showNotification(data.message, 'error')

        // Reset button after 3 seconds
        setTimeout(() => {
          button.querySelector('span').textContent = originalText
          button.classList.remove('bg-red-500', 'hover:bg-red-600')
          button.classList.add('bg-orange-500', 'hover:bg-orange-600')
          button.classList.remove('opacity-75', 'cursor-not-allowed')
          button.disabled = false
        }, 3000)
      }
    } catch (error) {
      console.error('Error syncing to Google Calendar:', error)

      button.querySelector('span').textContent = 'Sync Failed'
      button.classList.remove('bg-orange-500', 'hover:bg-orange-600')
      button.classList.add('bg-red-500', 'hover:bg-red-600')

      this.showNotification(
        'An error occurred while syncing to Google Calendar',
        'error'
      )

      // Reset button after 3 seconds
      setTimeout(() => {
        button.querySelector('span').textContent = originalText
        button.classList.remove('bg-red-500', 'hover:bg-red-600')
        button.classList.add('bg-orange-500', 'hover:bg-orange-600')
        button.classList.remove('opacity-75', 'cursor-not-allowed')
        button.disabled = false
      }, 3000)
    }
  }

  showNotification(message, type) {
    // Create notification element
    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg ${
      type === 'success' ? 'bg-green-500' : 'bg-red-500'
    } text-white max-w-md animate-fade-in-down`
    notification.textContent = message

    document.body.appendChild(notification)

    // Remove after 5 seconds
    setTimeout(() => {
      notification.classList.add('animate-fade-out-up')
      setTimeout(() => notification.remove(), 300)
    }, 5000)
  }
}
